import React from 'react';
import { AuthConsumer } from '../../providers/AuthProvider';
import Loader from '../../helpers/loader-full';

export const Logout = () => (
    <AuthConsumer>
        {({ logout }) => {
            logout();
            return <Loader />;
        }}
    </AuthConsumer>
);